class DesktopHeader extends HTMLDivElement {
  constructor () {
    super()

    this.els = {
      searchButton: this.querySelector('[data-desktop-header-el="search-button"]'),
      searchButtonIcon: this.querySelector('[data-desktop-header-el="search-button-icon"]'),
      searchButtonClose: this.querySelector('[data-desktop-header-el="search-button-close"]'),
    }
  }

  connectedCallback () {
    this.setupEventListeners()

    if (window.innerWidth >= 1200) {
      this.observeHeader()
    }
  }

  setupEventListeners () {
    this.els.searchButton.addEventListener('click', () => {
      this.classList.toggle('is-search-open')
      this.openAutoCompleteDropdown()

      if (this.classList.contains('is-search-open')) {
        this.els.searchButtonIcon.setAttribute('hidden', 'true')
        this.els.searchButtonClose.removeAttribute('hidden')

        this.querySelector('.hd-DesktopHeader_Right').querySelector(
          '.hd-Navigation_Nav',
        ).style.display = 'none'
      } else {
        this.els.searchButtonIcon.removeAttribute('hidden')
        this.els.searchButtonClose.setAttribute('hidden', 'true')

        setTimeout(() => {
          this.querySelector('.hd-DesktopHeader_Right').querySelector(
            '.hd-Navigation_Nav',
          ).style.display = 'flex'
        }, 100)

        this.closeAutoCompleteDropdown()
      }
    })
  }

  openAutoCompleteDropdown () {
    document.body.setAttribute('data-search-active', 'true')

    setTimeout(() => {
      this.querySelector('.aa-Input').focus()
    }, 100)
  }

  closeAutoCompleteDropdown () {
    document.body.setAttribute('data-search-active', 'false')
  }

  observeHeader () {
    const transparentOverMeSections = document.querySelectorAll('[data-transparent-over-me]')
    const announcementBarHeight = document.querySelector('.hd-AnnouncementBar')?.offsetHeight || 0
    const headerHeight = this.offsetHeight + announcementBarHeight

    const observer = new IntersectionObserver(
      entries => {
        let anyIntersecting = false

        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const top = entry.boundingClientRect.top - announcementBarHeight

            if (top <= 0) {
              anyIntersecting = true
            }
          }
        })

        if (anyIntersecting) {
          this.setTransparent()
        } else {
          this.removeTransparent()
        }
      },
      {
        root: null,
        rootMargin: `${headerHeight}px 0px -${headerHeight}px 0px`,
        threshold: [0, 0.1, 1.0], // Multiple thresholds for better detection
      },
    )

    transparentOverMeSections.forEach(section => {
      observer.observe(section)
    })
  }

  setTransparent () {
    if (!this.classList.contains('hd-DesktopHeader-transparent')) {
      this.classList.add('hd-DesktopHeader-transparent')
    }
  }

  removeTransparent () {
    if (this.classList.contains('hd-DesktopHeader-transparent')) {
      this.classList.remove('hd-DesktopHeader-transparent')
    }
  }
}

customElements.define('desktop-header', DesktopHeader, { extends: 'div' })
